import { render, staticRenderFns } from "./ButtonMarkProjectAsRecommended.vue?vue&type=template&id=6a6284de&scoped=true&"
import script from "./ButtonMarkProjectAsRecommended.vue?vue&type=script&lang=js&"
export * from "./ButtonMarkProjectAsRecommended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6284de",
  null
  
)

export default component.exports